module.exports = __webpack_public_path__ + "static/media/loginElement.36504139.svg";